import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../components/AuthContext";
import SignedOutHeader from "../../components/SignedOutHeader/SignedOutHeader";
import Footer from "../../components/Footer/Footer";
import { Button } from "@/components/ui/button";
import {
  SHUTDOWN_DATE_TEXT,
  SUPPORT_EMAIL,
  isAfterShutdown,
} from "../../shutdown";

export default function ShutdownPage() {
  const context = React.useContext(AuthContext);
  const closed = isAfterShutdown();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const Section = ({ title, children }) => (
    <section className="space-y-2">
      <h3 className="text-xl font-semibold text-neutral-50">{title}</h3>
      <div className="text-neutral-300 leading-relaxed space-y-2">{children}</div>
    </section>
  );

  return (
    <div className="pt-0 max-w-6xl px-6 my-0 mx-auto min-h-screen text-neutral-50">
      <SignedOutHeader context={context} />
      <div className="max-w-3xl mx-auto py-12 space-y-10">
        <header className="space-y-4">
          <h2 className="text-4xl font-extrabold">
            {closed
              ? "GameAway has shut down"
              : `GameAway is shutting down on ${SHUTDOWN_DATE_TEXT}`}
          </h2>
          <p className="text-lg text-neutral-300 leading-relaxed">
            After more than three years of bringing cloud gaming to India and
            beyond, we have made the hard decision to close GameAway. Thank you
            for playing with us. It meant a lot.
          </p>
        </header>

        {!closed && (
          <Section title={`What happens until ${SHUTDOWN_DATE_TEXT}`}>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                Existing accounts keep working. You can log in and use any
                playtime or Private PC subscription you already have.
              </li>
              <li>
                New signups and all purchases are closed. No new charges will be
                made to anyone.
              </li>
              <li>
                Active subscriptions will not renew. They end on their current
                billing date or on {SHUTDOWN_DATE_TEXT}, whichever comes first.
              </li>
            </ul>
          </Section>
        )}

        <Section title={`What happens ${closed ? "now" : `after ${SHUTDOWN_DATE_TEXT}`}`}>
          <ul className="list-disc pl-5 space-y-1">
            <li>Servers are switched off and the service stops.</li>
            <li>
              Private PC disks, game saves and account data are permanently
              deleted. Please copy anything you want to keep before the date.
            </li>
          </ul>
        </Section>

        <Section title="Prepaid hours and subscriptions">
          <p>
            Any playtime or Private PC subscription you have already paid for
            stays usable until {SHUTDOWN_DATE_TEXT}. Subscriptions will not
            renew, and nothing will be charged again. Unused time after the
            shutdown date lapses and is not refundable, so please make the most
            of it before then.
          </p>
        </Section>

        <Section title="Your game saves">
          <p>
            Most games sync saves to Steam Cloud, Epic or your store account
            automatically. If a game does not, move its save files to your
            own computer or cloud drive from your GameAway PC before{" "}
            {SHUTDOWN_DATE_TEXT}.
          </p>
        </Section>

        <Section title="Questions">
          <p>
            Write to{" "}
            <a className="underline" href={`mailto:${SUPPORT_EMAIL}`}>
              {SUPPORT_EMAIL}
            </a>
            . We will keep answering email for a while after the shutdown.
          </p>
        </Section>

        <div className="flex gap-3 pt-2">
          {!closed && (
            <Button asChild className="rounded-full">
              <Link to="/">Back to home</Link>
            </Button>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
